import { useEffect, useRef } from "react";

const useScroll = () => {
  const scrollRef = useRef<(HTMLDivElement | null)[]>([]);
  const scrollIntervals = useRef<(NodeJS.Timeout | null)[]>([]);

  const normalSpeed = 3;
  const fastSpeed = 1.5;
  const scrollDelay = 7;

  const handleMouseEnter = (i: number) => {
    const el = scrollRef.current[i];
    if (!el) return;

    // clear interval cũ của phần tử này
    if (scrollIntervals.current[i]) clearInterval(scrollIntervals.current[i]!);

    scrollIntervals.current[i] = setInterval(() => {
      if (!el) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight) {
        clearInterval(scrollIntervals.current[i]!);
      } else {
        el.scrollTop += fastSpeed;
      }
    }, scrollDelay);
  };

  const handleMouseLeave = (i: number) => {
    const el = scrollRef.current[i];
    if (!el) return;

    if (scrollIntervals.current[i]) clearInterval(scrollIntervals.current[i]!);

    scrollIntervals.current[i] = setInterval(() => {
      if (!el) return;
      if (el.scrollTop <= 0) {
        clearInterval(scrollIntervals.current[i]!);
      } else {
        el.scrollTop -= normalSpeed;
      }
    }, scrollDelay);
  };

  useEffect(() => {
    const intervals = scrollIntervals.current;

    return () => {
      intervals.forEach((interval) => {
        if (interval) clearInterval(interval);
      });
    };
  }, []);

  return { scrollRef, handleMouseEnter, handleMouseLeave };
};

export default useScroll;
